var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewCollapseOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_377_49320)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 27,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "rotate(-90 0 27)",
    fill: "#3772FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8106 12.6121L13.9994 16.4233C13.922 16.5008 13.84 16.5564 13.7535 16.5901C13.667 16.6238 13.5747 16.6406 13.4766 16.6406C13.3785 16.6406 13.2862 16.6238 13.1997 16.5901C13.1131 16.5564 13.0312 16.5008 12.9537 16.4233L9.12937 12.599C8.98453 12.4541 8.91211 12.2777 8.91211 12.0696C8.91211 11.8615 8.98453 11.685 9.12937 11.5402C9.27422 11.3953 9.45288 11.3251 9.66535 11.3295C9.87781 11.3339 10.0565 11.4085 10.2013 11.5533L13.4766 14.8286L16.765 11.5402C16.9098 11.3953 17.0841 11.3229 17.2878 11.3229C17.4915 11.3229 17.6658 11.3953 17.8106 11.5402C17.9555 11.685 18.0279 11.8637 18.0279 12.0762C18.0279 12.2886 17.9555 12.4673 17.8106 12.6121Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.516167,
    y: 26.4838,
    width: 25.9677,
    height: 25.9677,
    rx: 12.9838,
    transform: "rotate(-90 0.516167 26.4838)",
    stroke: "#3772FF",
    strokeWidth: 1.03233
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_377_49320"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 27,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "rotate(-90 0 27)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCollapseOpenIcon);
export default __webpack_public_path__ + "static/media/newCollapseOpenIcon.30a016eb.svg";
export { ForwardRef as ReactComponent };